// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2DC1t","inputWrap":"Table_inputWrap__Cznvg","col":"Table_col__EtecC","bmiTooltip":"Table_bmiTooltip__2oa-V"};